import { render } from "./ModuleResultDetail.vue?vue&type=template&id=161b8d9b&scoped=true"
import script from "./ModuleResultDetail.vue?vue&type=script&lang=js"
export * from "./ModuleResultDetail.vue?vue&type=script&lang=js"

import "./ModuleResultDetail.vue?vue&type=style&index=0&id=161b8d9b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161b8d9b"]])

export default __exports__